import {
  AcceptedTermsPreparedState,
  portfolioApi,
  PortfolioPageState,
  PortfolioResponse,
  updateStore,
} from "./portfolioDomain";
import { compact, join } from "lodash";
import { EventDispatcher, showAlert, showGeneralError } from "../events/eventsDomain";

export const prepAcceptedTermsState = (
  portfolioState: PortfolioPageState | undefined,
  response: PortfolioResponse,
  dispatch: EventDispatcher,
): AcceptedTermsPreparedState | undefined => {
  const readyState = portfolioState?.type === "ready" ? portfolioState : undefined;
  const acceptedTerms = response.user.acceptedTerms;
  const maxNumberOfCompanies = 5;
  const commaSeparatedCompanies = join(
    readyState?.userCompaniesInPortfolio?.map((it) => it.name).slice(0, maxNumberOfCompanies),
    ", ",
  );
  if (!readyState) {
    return undefined;
  }

  const acceptedTermsModel = readyState.acceptTermsCheckbox;
  const emailModel = readyState.acceptTermsEmail;

  const validate = () => {
    acceptedTermsModel.validate();
    emailModel.validate();
    return acceptedTermsModel.isValid && emailModel.isValid;
  };

  const acceptUserTermsAndUpdateEmailAddress = () => {
    if (validate()) {
      dispatch(
        compact([
          readyState &&
            updateStore(readyState, {
              isAcceptingTerms: true,
            }),
          portfolioApi.acceptUserTermsAndUpdateEmail({
            data: { email: emailModel.validatedValue! },
            onSuccess: (_, current) =>
              compact([
                current.portfolioState?.type === "ready" &&
                  updateStore(current.portfolioState, {
                    isAcceptingTerms: undefined,
                    portfolioResponse: {
                      ...current.portfolioState.portfolioResponse,
                      user: {
                        ...current.portfolioState.portfolioResponse.user,
                        acceptedTerms: true,
                      },
                    },
                  }),
                showAlert({ key: "general-success" }),
              ]),
            onFailure: (_, current) =>
              compact([
                current.portfolioState?.type === "ready" &&
                  updateStore(current.portfolioState, { isAcceptingTerms: undefined }),
                showGeneralError(),
              ]),
          }),
        ]),
      );
    }
  };

  return {
    acceptedTerms,
    emailModel,
    acceptedTermsModel,
    commaSeparatedCompanies,
    acceptUserTermsAndUpdateEmailAddress,
    numberOfCompanies: readyState.userCompaniesInPortfolio.length ?? 0,
    fullName: response.user.name,
    isAcceptingTerms: readyState.isAcceptingTerms,
  };
};
